import TyRemark from './TyRemark.vue'
export default TyRemark



// WEBPACK FOOTER //
// ./src/components/ty-remark/index.js